import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "#9DA4B4",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M3.515 5.567a.617.617 0 0 1 .942 0l3.529 3.951 3.529-3.95a.7.7 0 0 1 .216-.18.61.61 0 0 1 .75.15.8.8 0 0 1 .149.252.83.83 0 0 1-.014.59.8.8 0 0 1-.16.242l-4 4.48a.63.63 0 0 1-.47.218.63.63 0 0 1-.471-.218l-4-4.48a.8.8 0 0 1-.195-.527c0-.198.07-.388.195-.528",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }